// Prevent multiple-clickes from generating multiple server calls.
window.disableNetPromoter = function disableNetPromoter() {
  $(document).off('click', '#popup-content a.close');
  $(document).off('click', '#popup-content a.skip');
  $(document).off('submit', '#netpromoter-advanced');
};

/**
 * Submit the score to the API to be saved inside the DB,
 * in parallel sends a track event to Mixpanel
 * @param {Number} score - Score from 1 to 11. 11 is when the customer presses "Skip"
 * @param {String} [feedback] - Optional note from the customer
 */
window.submitNetPromoter = function submitNetPromoter(score: number | string, feedback?: string) {
  let xml = `<NetPromoter><score>${score}</score>`;
  xml += `<additionalFeedback>${feedback || ''}</additionalFeedback></NetPromoter>`;

  window.lsCloud
    .startServerJob(
      {
        type: 'POST',
        url: '/API/NetPromoter',
        data: xml,
      },
      true
    )
    .always(data => {
      window.hideNetPromoter();
      if (typeof data !== 'object') return;
      window.lsCloud.analytics.track(
        'NPS',
        {
          score: parseInt(String(score), 10),
          NPS: parseInt(String(score), 10),
          // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
          id: window.merchantos.session.sessData.systemCustomerID,
          // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
          system_account_id: window.merchantos.session.sessData.systemCustomerID,
          // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
          system_user_id: window.merchantos.session.sessData.systemUserID,
          additional_feedback: feedback || '',
          // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
          is_admin: window.merchantos.session.sessData.Rights.admin,
          // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
          is_owner: window.merchantos.session.sessData.Rights.owner,
          net_promoter_id: $(data)
            .find('netPromoterID')
            .text(),
          NPS_date: window
            .moment()
            .utc()
            .startOf('day')
            .toISOString(),
          score_timestamp: window.moment().toISOString(),
        },
        ''
      );
    });
};

window.hideNetPromoter = function hideNetPromoter() {
  $('#popup').removeClass('active');
  // eslint-disable-next-line camelcase
  const content_map = {} as ContentMap;
  content_map.form_name = 'net_promoter';
  window.doServerCall(content_map, () => false);
};

$(() => {
  if ($('#netpromoter').is(':visible')) {
    const hideNetPromoterTimeout = setTimeout(() => window.hideNetPromoter(), 30000);

    $(document).on('click', '#netpromoter', () => clearTimeout(hideNetPromoterTimeout));
  }
});

$(document).on('click.netpromoter', '#netpromoter .recommendation-label', event => {
  $(document).off('click.netpromoter', '#netpromoter .recommendation-label');

  const score = $(`#${event.target.htmlFor}`).val() as number;

  let netPromoterTimeout: TSFixMe;

  setTimeout(() => {
    const popup = $('#popup');
    popup.find('#netpromoter').hide();
    popup.find('#netpromoter-thankyou').fadeIn();

    netPromoterTimeout = setTimeout(() => {
      $('#popup').removeClass('active');
      window.submitNetPromoter(score);
    }, 10000);
  }, 500);

  $(document).on('focus', '#netpromoter-advanced textarea', () => clearTimeout(netPromoterTimeout));

  $(document).on('submit.netpromoter', '#netpromoter-advanced', () => {
    clearTimeout(netPromoterTimeout);
    $(document).off('submit.netpromoter', '#netpromoter-advanced');
    const feedback = $('#netpromoter-text').val() as string;
    window.submitNetPromoter(score, feedback);
  });
});

$(document).on('submit', '#netpromoter-advanced', event => event.preventDefault());

$(document).on('click', '#popup-content a.close, #popup-content a.skip', event => {
  event.preventDefault();
  $('#popup').hide();
  // Check if a score was selected.
  let score = $('input[name=recommendation]:checked', '#netpromoter').val() as string | number;

  // If not score was selected, submit a score of 11 with no feedback so that
  // hiding can be tracked / filtered out later.
  score = score || 11;
  window.disableNetPromoter();
  window.submitNetPromoter(score);
});
